export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1920w.9903e722.webp";